import fetchToBackend from "@/utils/fetchToBackend";

// Better Auth's api-key plugin mounts its endpoints under the auth base path
// (`/api/auth`). We call them directly to stay independent of the client
// plugin (which isn't bundled in this better-auth build).

export interface ApiKey {
  id: string;
  name?: string | null;
  start?: string | null;
  createdAt?: string;
}

export async function listApiKeys(): Promise<ApiKey[]> {
  const res = await fetchToBackend<any>("/auth/api-key/list");
  if (Array.isArray(res)) return res;
  return res?.apiKeys ?? res?.data ?? [];
}

export async function createApiKey(name: string): Promise<{ key?: string }> {
  return fetchToBackend<any>("/auth/api-key/create", {
    method: "POST",
    body: JSON.stringify({ name }),
  });
}

export async function deleteApiKey(keyId: string): Promise<void> {
  await fetchToBackend("/auth/api-key/delete", {
    method: "POST",
    body: JSON.stringify({ keyId }),
  });
}
